(function(){
  var reduce = matchMedia('(prefers-reduced-motion:reduce)').matches;

  /* reveal on scroll */
  var targets = document.querySelectorAll(
    'article p, article h2, article figure, .tried, .science, .pull, .split, .cta, .guarantee, .reviews h2, .reviews .sub, .r-card'
  );
  targets.forEach(function(el){ el.classList.add('reveal'); });
  if(reduce || !('IntersectionObserver' in window)){
    targets.forEach(function(el){ el.classList.add('in'); });
  } else {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, {rootMargin:'0px 0px -8% 0px', threshold:0.08});
    targets.forEach(function(el){ io.observe(el); });
  }

  /* sticky product: show immediately at top of page */
  var pcard = document.getElementById('pcard');
  var pbar  = document.getElementById('pbar');
  function reveal(){ pcard.classList.add('show'); pbar.classList.add('show'); }
  reveal();
  document.getElementById('pcardClose').addEventListener('click', function(){
    pcard.classList.remove('show'); pbar.classList.remove('show');
  });
})();
